import { Popper, PopperPlacementType } from '@material-ui/core'
import React, { PropsWithChildren, useRef, useState } from 'react'

const ModalCompatTooltip = ({
    delay = 250,
    transitionMs = 150,
    content,
    popperContainerStyle = {},
    childContainerStyle = {},
    popperStyleOverride = {},
    direction = 'bottom',
    isBrowserTooltip = false,
    isEnabled = true,
    isSticky = false,
    disablePortal = true,
    children,
}: PropsWithChildren<{
    delay?: number
    transitionMs?: number
    // if isBrowserTooltip, then content must be string.
    content: React.ReactNode | string
    popperContainerStyle?: React.CSSProperties
    childContainerStyle?: React.CSSProperties
    popperStyleOverride?: React.CSSProperties
    direction?: PopperPlacementType
    isBrowserTooltip?: boolean
    isEnabled?: boolean
    isSticky?: boolean
    disablePortal?: boolean
}>) => {
    const showTimeout = useRef<NodeJS.Timeout | null>(null)
    const preshowTimeout = useRef<NodeJS.Timeout | null>(null)

    const [isPreshow, set_isPreshow] = useState(false)
    const [isShow, set_isShow] = useState(false)
    const isStickiedRef = useRef<boolean>(false)

    const anchorEl = useRef(null)

    const show = () => {
        preshowTimeout.current && clearTimeout(preshowTimeout.current)
        set_isPreshow(true)

        showTimeout.current = setTimeout(() => {
            set_isShow(true)
        }, delay)
    }

    const hide = () => {
        showTimeout.current && clearTimeout(showTimeout.current)
        set_isShow(false)

        preshowTimeout.current = setTimeout(() => {
            set_isPreshow(false)
        }, transitionMs)

        isStickiedRef.current = false
    }

    if (!isEnabled) {
        return <div style={childContainerStyle}>{children}</div>
    }

    if (isBrowserTooltip) {
        return (
            <div
                style={{ display: 'contents', ...childContainerStyle }}
                title={typeof content === 'string' ? content : '?'}
            >
                {children}
            </div>
        )
    } else {
        return (
            <div ref={anchorEl} style={popperContainerStyle}>
                <div
                    style={childContainerStyle}
                    onMouseEnter={() => show()}
                    onMouseLeave={() => (!isSticky || isStickiedRef.current === false) && hide()}
                    onClick={() => hide()}
                >
                    {children}
                </div>
                <Popper
                    open={!!anchorEl.current && isPreshow}
                    anchorEl={anchorEl.current}
                    placement={direction}
                    style={{
                        marginTop: 4,
                        padding: '5px 9px',
                        color: '#f1f1f1',
                        backgroundColor: 'rgba(97, 97, 97, 0.95)',
                        fontSize: '11px',
                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                        lineHeight: 1.4,
                        borderRadius: 4,
                        zIndex: 999999,
                        textTransform: 'none',
                        transition: `opacity 100ms, visibility 100ms`,
                        maxWidth: 300,
                        ...(isShow ? { opacity: 1, visibility: 'visible' } : { opacity: 0, visibility: 'hidden' }),
                        ...popperStyleOverride,
                    }}
                    // example of arrow: https://github.com/mui-org/material-ui/blob/4f2a07e140c954b478a6670c009c23a59ec3e2d4/docs/src/pages/components/popper/ScrollPlayground.js
                    // modifiers={[{name:'arrow', enabled:true}]}
                    disablePortal={disablePortal}
                    onMouseEnter={() => {
                        if (isSticky) {
                            isStickiedRef.current = true
                        }
                    }}
                    onMouseLeave={() => hide()}
                >
                    <div>{content}</div>
                </Popper>
            </div>
        )
    }
}

export default ModalCompatTooltip
